import type { ComponentsOverrides, ComponentsVariants, ComponentsProps } from '@mui/material';
import type { SxProps } from '@mui/material/styles';
import type { Theme } from '@ui/ThemeRegistry/theme.types';
import type { ContentModuleProps } from '@ui/ContentModule/ContentModule.types';

import type { Media_BaseFragmentFragment } from '@graphql-sdk/types';

export interface FileProps {
  url?: string;
  width?: string;
  height?: string;
}

export interface AssetProps {
  file: FileProps;
  title?: string;
  description?: string;
}

export enum MediaVariants {
  default = 'default',
  circle = 'circle',
  bordered = 'bordered'
}

export interface MediaProps extends ContentModuleProps {
  /**
   * The variant to use.
   * @default default
   */
  variant?: MediaVariants;

  /**
   * The image source URL.
   */
  src?: string;

  /**
   * The image alt text.
   */
  alt?: string;

  /**
   * The image title.
   */
  title?: string;

  /**
   * Whether to use next.js image optimization.
   * @default true
   */
  nextImageOptimization?: boolean;

  /**
   * Whether to prioritize loading of the image.
   * @default false
   */
  priority?: boolean;

  /**
   * The sizes attribute for the image.
   * @default '100vw'
   */
  sizes?: string;

  /**
   * The sx prop for custom styles.
   */
  sx?: SxProps<Theme>;

  testId?: string;
  disableInlineSVG?: boolean;
  q?: number;
  unoptimized?: boolean;
  imageOverlayColor?: string;
  aspectRatio?: string;
  columns?: any;
}

export interface MediaOwnerState extends MediaProps {
  variant: MediaVariants;
}

export interface MediaVideoProps extends MediaProps {
  controls?: boolean;
}

interface MediaClasses {
  /** Styles applied to the root element. */
  root: string;
}

export declare type MediaClassKey = keyof MediaClasses;
declare module '@mui/material/styles' {
  export interface ComponentNameToClassKey {
    Media: MediaClassKey;
  }

  export interface ComponentsPropsList {
    Media: MediaProps;
  }
}

declare module '@mui/material/styles' {
  interface Components {
    Media?: {
      defaultProps?: ComponentsProps['Media'];
      styleOverrides?: ComponentsOverrides<Theme>['Media'];
      variants?: ComponentsVariants['Media'];
    };
  }
}
